import { useEffect, useState } from 'react';

export default function useDebouncedValue(value, delay = 400) {
    const [settled, setSettled] = useState(value);
    useEffect(() => {
        if (value === '') {
            setSettled('');
            return undefined;
        }
        const timer = setTimeout(() => setSettled(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);
    // Clearing a search restores the full list immediately.
    return value === '' ? '' : settled;
}
